/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
async function n(n,r){try{return await n}catch(t){if("no-queryEngine"!==t.name)throw t;return r}}export{n as handleNoEngineError};
